import React, { Component } from 'react';
import { Card, Col, Form, InputNumber, Row, Checkbox } from 'antd';

export class StopLossForm extends Component {
    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <Card title="Stop Loss" bordered={false} style={{ marginBottom: 15 }}>
                <Row gutter={24}>
                    <Col md={12}>
                        <Form.Item label="Enable stop loss">
                            {getFieldDecorator('stoploss_enabled', {
                                valuePropName: 'checked',
                                initialValue: false
                            })(<Checkbox>Yes</Checkbox>)}
                        </Form.Item>
                    </Col>

                    <Col md={12} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item label="Percentage">
                            {getFieldDecorator('stoploss_percentage', {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 0
                            })(<InputNumber min={0} />)}
                        </Form.Item>
                    </Col>

                    <Col md={12} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item label="When stop loss triggered disable symbol">
                            {getFieldDecorator('stoploss_cooldown_enabled', {
                                valuePropName: 'checked',
                                initialValue: false
                            })(<Checkbox>Yes</Checkbox>)}
                        </Form.Item>
                    </Col>

                    <Col md={12} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item label="Disable symbol for how long (mins)">
                            {getFieldDecorator('stoploss_cooldown_time', {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 60
                            })(<InputNumber />)}
                        </Form.Item>
                    </Col>
                </Row>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/Standard/Shared/StopLossForm.js